import {CLEnumsMapper, CLEnumType} from 'common/src/modules/enums/enums.types';
import Subject from 'common/src/utils/pubsub/subject';

/**
 * Loaded enums
 * @description This is a global object that contains all the loaded enums.
 * It is used to avoid loading enums lazily.
 * Loading these enums is done in the initializeApp thunk.
 */
const loadedEnumsSubject = new Subject<Partial<Record<CLEnumType, Record<string, CLEnumsMapper>>>>(
  {},
);

export {loadedEnumsSubject};
